/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent } from 'react';
import { Box, Dialog, IconButton } from '@mui/material';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  open: boolean;
  imagePokaz: any;
  onClose: () => void;
}

export const DialogOpenImageItemDiv: FunctionComponent<Props> = ({
  open,
  imagePokaz,
  onClose,
}) => {
  const handleClose = () => {
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-label="Изображение инструкции"
      fullWidth
      PaperProps={{
        sx: {
          background: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
          width: '100%',
          maxWidth: '100%', // ← убирает ограничение ширины
          margin: 0, // ← убирает внешние отступы
          padding: 1, // ← убирает внутренние отступы
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <IconButton
          aria-label="Закрыть изображение"
          onClick={() => handleClose()}
          sx={{
            position: 'absolute',
            top: -40,
            right: 0,
            color: '#fff',
            zIndex: 2,
          }}
        >
          <CloseIcon />
        </IconButton>

        <TransformWrapper
          initialScale={1}
          minScale={0.5}
          maxScale={5}
          doubleClick={{ mode: 'zoomIn' }}
          wheel={{ step: 0.1 }}
          pinch={{ step: 5 }}
          centerOnInit
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              {/* Кнопки управления */}

              <TransformComponent
                wrapperStyle={{
                  width: '100%',
                  height: '80vh',
                  overflow: 'hidden',
                }}
                contentStyle={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={imagePokaz}
                  alt="Иллюстрация инструкции"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    userSelect: 'none',
                  }}
                  draggable={false}
                />
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </Box>
    </Dialog>
  );
};
